export const COLORS = {
  brand: {
    primary: "#0656ab",
    ticketHeader: "#001d4f",
  },
  success: "#28a745",
  error: "#dc3545",
  chart: {
    sold: {
      border: "rgba(75, 192, 192, 1)",
      background: "rgba(75, 192, 192, 0.2)",
    },
    succPassed: {
      border: "rgba(192, 118, 75, 1)",
      background: "rgba(192, 118, 75, 0.2)",
    },
    passed: {
      border: "rgba(167, 65, 141, 1)",
      background: "rgba(167, 65, 141, 0.2)",
    },
    weekend: {
      fill: "rgba(221, 228, 0, 0.4)",
      legendFill: "rgba(221, 228, 0, 0.3)",
      legendStroke: "rgba(221, 228, 0, 1)",
    },
  },
};